import React, {
    useState, useEffect, useCallback, memo, useRef, Fragment
} from 'react';
import {
    IconCareerLevel,
    IconDepartment,
    IconEducationLevel,
    IconHoursPerWeek,
    IconLocationMarker,
    IconSalary,
    IconHeart,
    IconShare
} from '@searchComponents/icons';

import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { getCookie, setCookie } from '../../../../utils/cookies';
import { addToWishListAction } from '../../../wishListPage/store/actions';
import Popover from '../../../../Components/Popover';
import ShareCard from '../../../../Components/ShareCard';
import { translations } from '../../../../utils/translations';

/**
 * A Intl.NumberFormat instance to format the number.
 * @var {Intl.NumberFormat<>}
 */
const formatter = new Intl.NumberFormat('nl-NL', {
    style: 'decimal'
});

const JobCard = memo(({
                          result, index, total
                      }) => {
    const [show, setShow] = useState(false);
    const [isFavour, setFavour] = useState(false);
    const popoverRef = useRef(null);
    const dispatch = useDispatch();
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";
    const translate = (s) => translations[lang][s] || s;

    const onHidePopover = useCallback((event) => {
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setShow(false);
    }, []);

    useEffect(() => {
        if (popoverRef.current) {
            popoverRef.current.focus();
        }
    }, [show]);

    const addToFavour = (event) => {
        const card = event.currentTarget.dataset.id;

        let favoursCard = null;
        if (!getCookie('favour')) {
            favoursCard = {};
        } else {
            favoursCard = JSON.parse(getCookie('favour'));
        }

        if (card in favoursCard) {
            setFavour(false);
            const { [card]: removeCard, ...cards } = favoursCard;
            setCookie('favour', JSON.stringify(cards));
            dispatch(addToWishListAction({ [card]: false }));
        } else {
            setFavour(true);
            // eslint-disable-next-line max-len
            setCookie('favour', JSON.stringify({
                ...favoursCard,
                [event.currentTarget.dataset.id]:
                    {
                        status: true,
                        title: result.post_title,
                        link: result.post_link
                    }
            }));
            dispatch(addToWishListAction({
                [card]: {
                    status: true,
                    title: result.post_title,
                    link: result.post_link
                }
            }));
        }
    };

    let checkCardFav = null;
    if (getCookie("favour")?.includes(result.ID)) {
        checkCardFav = true;
    } else {
        checkCardFav = false;
    }

    const delay = 75;
    const animationDelay = `${index * delay}ms`;
    const zIndex = `${-(index - total)}`;

    return (
        <li className={`job-search__item`} id={`card-${result.ID}`} style={{ animationDelay, zIndex }}>
            <a
                href={result.post_link} rel="noopener"
                className={`job-search__card`}
                // style={result?.company?.accentColor && { '--accent-color': result?.company.accentColor }}
            >
                <div className={`job-search__card-image`}>
                    {result?.status.length && result?.status === 'internal' && <div className={`job-search__card-image-status`} dangerouslySetInnerHTML={{__html: 'Intern'}}/>}
                    {result?.fields?.employment_type === 'FLEX' && <div className={`job-search__card-image-flex`} dangerouslySetInnerHTML={{__html: 'Flex'}}/>}
                    {result?.post_featured_image.length && <div className={`job-search__card-image-wrapper`} dangerouslySetInnerHTML={{__html: result.post_featured_image}}/>}
                    {result?.company?.logo ? (
                        <figure className={`job-search__card-logo`}>
                            <img src={result?.company.logo} alt="" />
                        </figure>
                    ) : (
                        <figure className={`job-search__card-logo`}>
                            <img src={'/app/plugins/louwman-job-search/public/images/louwman-logo.svg'} width="100px" alt="Logo Louwman" />
                        </figure>
                    )}
                </div>
                <div className={'job-search__card-detail'}>
                    <div className={'job-search__card-description'}>
                        <div className={`job-search__card-header`}>
                            <h5 className={`job-search__card-title`} dangerouslySetInnerHTML={{ __html: result.post_title }} />
                        </div>
                        <div className={`job-search__card-footer`}>
                            <ul className={`job-search__card-info`}>
                                {((result?.terms?.['recruitee-city']?.length > 0)
                                    && (result?.terms?.['recruitee-city']?.some((city) => city))
                                    || (result?.terms?.['recruitee-state-name']?.length > 0)
                                    && (result?.terms?.['recruitee-state-name']?.some((state) => state))) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}>
                                            <IconLocationMarker />
                                        </div>
                                        <span className={`fs_facet-search--infoText`}>
                                            {[
                                                result.terms['recruitee-city']?.filter(Boolean).join(' • ') || '',
                                                result.terms['recruitee-state-name']?.filter(Boolean).join(', ') || ''
                                            ].filter(Boolean).join(', ')}
                                        </span>
                                    </li>
                                )}
                                {(result?.terms?.['recruitee-experience-code']?.length > 0)
                                    && (result?.terms?.['recruitee-experience-code']?.some((exp) => exp)) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}><IconCareerLevel /></div>
                                        <span className={`fs_facet-search--infoText`}>
                                            {result.terms['recruitee-experience-code'].filter(Boolean).join(' • ')}
                                        </span>
                                    </li>
                                )}
                                {(result?.terms?.['recruitee-category-code']?.length > 0)
                                    && (result?.terms?.['recruitee-category-code']?.some((cat) => cat)) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}><IconDepartment /></div>
                                        <span className={`fs_facet-search--infoText`}>
                                            {result.terms['recruitee-category-code'].filter(Boolean).join(' • ')}
                                        </span>
                                    </li>
                                )}
                                {(result?.terms?.['recruitee-education']?.length > 0)
                                    && (result?.terms?.['recruitee-education']?.some((edu) => edu)) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}><IconEducationLevel /></div>
                                        <span className={`fs_facet-search--infoText`}>
                                            {result.terms['recruitee-education'].filter(Boolean).join(' • ')}
                                        </span>
                                    </li>
                                )}
                                {(result?.fields?.max_hours_per_week)
                                    && (result?.fields?.min_hours_per_week)
                                    && (parseInt(result?.fields?.min_hours_per_week) > 0)
                                    && (parseInt(result?.fields?.max_hours_per_week) > 0) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}>
                                            <IconHoursPerWeek />
                                        </div>
                                        <span className={`fs_facet-search--infoText`}>
                                            {
                                                result.fields.min_hours_per_week === result.fields.max_hours_per_week ? (
                                                    <>{result.fields.min_hours_per_week}{" "}{translate("hours")}</>
                                                ) : (
                                                    <>
                                                        {result.fields.min_hours_per_week}-{result.fields.max_hours_per_week}{" "}{translate("hours")}
                                                    </>
                                                )}
                                        </span>
                                    </li>
                                )}
                                {(result?.fields?.salary?.min)
                                    && (result?.fields?.salary?.max)
                                    && (parseInt(result?.fields?.salary?.min) > 0)
                                    && (parseInt(result?.fields?.salary?.max) > 0) && (
                                    <li className={`job-search__card-info--item`}>
                                        <div className={`job-search__card-info--icon`}>
                                            <IconSalary />
                                        </div>
                                        <span className={`job-search__card-info--text`}>
                                          {parseInt(result.fields.salary.min) === parseInt(result.fields.salary.max) ? (
                                              <>€ {formatter.format(result.fields.salary.min)}</>
                                          ) : (
                                              <>
                                                  € {formatter.format(result.fields.salary.min)} -{' '}
                                                  {formatter.format(result.fields.salary.max)}
                                              </>
                                          )}
                                        </span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className={`job-search__card-body`}>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: result.post_first_paragraph
                                }}
                            />
                    </div>
            </div>
        </a>
        </li>
    );
});

export default JobCard;
